import { Activity } from "lucide-react";
import type { ReactElement } from "react";
import { Link } from "react-router-dom";

import { showCookieSettings } from "components/auth/CookieConsent";
import { FOOTER_LINKS } from "content/landing";

/**
 * Site footer with legal links, status link, and cookie settings.
 */
export function Footer(): ReactElement {
  return (
    <footer id="contact" className="bg-background py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div
          className="flex flex-col items-center justify-between gap-6 border-t border-border pt-8 sm:flex-row"
          data-landing-scroll-anchor
        >
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
            <Link
              to="/muggleTestV0/health"
              className="inline-flex items-center gap-1 transition-colors hover:text-foreground"
            >
              <Activity className="h-3.5 w-3.5" aria-hidden="true" />
              <span>Status</span>
            </Link>
            {FOOTER_LINKS.map((link) =>
              link.href === "#cookie-settings" ? (
                <button
                  key={link.label}
                  type="button"
                  onClick={showCookieSettings}
                  className="transition-colors hover:text-foreground"
                >
                  {link.label}
                </button>
              ) : link.isExternal || link.href.startsWith("mailto:") || link.href === "#" ? (
                <a key={link.label} href={link.href} className="transition-colors hover:text-foreground">
                  {link.label}
                </a>
              ) : (
                <Link key={link.label} to={link.href} className="transition-colors hover:text-foreground">
                  {link.label}
                </Link>
              )
            )}
          </div>
          <div className="text-sm text-muted-foreground">© {new Date().getFullYear()} Muggle Test</div>
        </div>
      </div>
    </footer>
  );
}
